'use strict';

function createCookie (name, value, days) {
    var expires;

    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
    } else {
        expires = '';
    }
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/';
}

function readCookie (name) {
    var nameEQ = encodeURIComponent(name) + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
    }
    return null;
}

function eraseCookie (name) {
    createCookie(name, '', -1);
}
class Geoblock {
    init () {
        this.lastCountryVisitedKey = 'lastVisited';
        if ($('.cc-geoblock').length !== 0) {
            this.isBannerVisible = $('.cc-geoblock').hasClass('hide');
            this.observeCloseButton();
            this.countryCheck();
            this.updateBubbleChatPosition();
            this.updateSmartGiftBasketButton();
        }
    }

    observeCloseButton () {
        var _self = this;
        $('.js-geoblock-container_close').on('click', function (e) {
            createCookie(_self.lastCountryVisitedKey, _self.getCurrentCountry());
            $('.js-geoblock-container').addClass('hide');
            _self.isBannerVisible = false;
            $('#esw-fab').attr('style', '').removeAttr('style');
            $('.SGBasketButton').attr('style', '').removeAttr('style');
        });
    }

    countryCheck () {
        var _self = this;
        let lastCountryVisited = readCookie(this.lastCountryVisitedKey);
        let currentCountry = _self.getCurrentCountry();
        let physicalCountry = _self.getPhysicalCountry();

        if (lastCountryVisited !== null) {
            if (lastCountryVisited !== currentCountry) {
                eraseCookie(_self.lastCountryVisitedKey);

                // Show new country
                if (currentCountry !== physicalCountry) {
                    $('.js-geoblock-container').removeClass('hide');
                }
            } else {
                $('.js-geoblock-container').addClass('hide');
            }
        } else {
            if (currentCountry !== physicalCountry) {
                $('.js-geoblock-container').removeClass('hide');
            }
        }
    }

    getCurrentCountry () {
        return ($('.js-geoblock-container_country').data('current-country') || '').toLowerCase();
    }

    getPhysicalCountry () {
        return ($('.js-geoblock-container_country').data('physical-country') || '').toLowerCase();
    }

    updateBubbleChatPosition () {
        var _self = this;
        $(window).on('scroll', function () {
            let $bubbleChat = $('#esw-fab');
            if (!_self.isBannerVisible || !$bubbleChat.length) {
                return;
            }

            let newBottomValue = Foundation.MediaQuery.atLeast('large') ? '96' : '84';
            $bubbleChat.attr('style', `bottom: ${newBottomValue}px !important;`);
        });
    }

    updateSmartGiftBasketButton () {
        var checkWidget = setInterval(function () {
            let smartGiftBasketBtn = $('.SGBasketButton');

            if (smartGiftBasketBtn.length) {
                $('.SGBasketButton').attr('style', 'bottom: 60px !important');
                clearInterval(checkWidget);
            }
        }, 1500);
    }
}

let geoblockHelper = new Geoblock();
export default geoblockHelper;
